import { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { GreenSkyIovation } from './GreenSkyIovation';

export const useGreenSkyIovation = () => {
    const [fingerprint, setFingerprint] = useState<string>('');

    const handleFingerprintCapture = useCallback((fp: string) => {
        setFingerprint(fp);
    }, []);

    const iovationComponent = createPortal(
        <GreenSkyIovation onFingerprintCapture={handleFingerprintCapture} />,
        document.body,
    );

    return {
        fingerprint,
        iovationComponent,
    };
};
